export const versions = {
  version: "1.0.183",
  revision: "0ea566c12",
  branch: "HEAD",
  gitInfo: {
    dirty: true,
    raw: "v1.0.183-5161-g0ea566c12-dirty",
    hash: "g0ea566c12",
    distance: 5161,
    tag: "v1.0.183",
    semver: {
      options: { loose: false, includePrerelease: false },
      loose: false,
      raw: "v1.0.183",
      major: 1,
      minor: 0,
      patch: 183,
      prerelease: [],
      build: [],
      version: "1.0.183"
    },
    suffix: "5161-g0ea566c12-dirty",
    semverString: "1.0.183+5161.g0ea566c12.dirty"
  }
};
